import { UseCase } from "../../useCase"
import { GetSurveySectionsResponse } from "./response"
import { GetSurveySectionsRequest } from "./request"
import { SurveyRepository } from "../../../repositories/surveyRepository"

export class GetSurveySectionsUseCase implements UseCase<GetSurveySectionsRequest, GetSurveySectionsResponse> {
	private _repository
	constructor({ SurveyRepository }: { SurveyRepository: SurveyRepository }) {
		this._repository = SurveyRepository
	}

	exec() {
		return this._repository.getSurveySections()
	}
}
